export default "__VITE_ASSET__OOlo4vrQ__"